const FromArr = [{
		title: "产品型号：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 35,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "医院名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 50,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "植入时间：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 50,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [{
			key: 0,
			value: '今日'
		}, {
			key: 1,
			value: '明日'
		}]
	},
	{
		title: "日期区间：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "选择时间",
		widthLeft: 247,
		widthRight: 247,
		heightLeft: 32,
		heightRight: 32,
		disabled: false,
		marginLeft: 35,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "省份：",
		inputtype: "select",
		inputflag: true,
		multiple: true,
		collapseTags: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 78,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		title: "销售：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 63,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500
	}
]
export default FromArr;